// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ix-c";
export var backButton = "_ix-4";
export var backIcon = "_ix-5";
export var chevronShortcut = "_ix-6";
export var container = "_ix-1";
export var editor = "_ix-8";
export var editorWrapper = "_ix-7";
export var prefix = "_ix-2";
export var searchIcon = "_ix-3";
export var suffix = "_ix-9";
export var suffixContent = "_ix-a";
export var suffixText = "_ix-b";
export var wrapper = "_ix-0";